import type { AnyGraphNode } from '../types/graphNodes';

const LYRICS_EDGE = 'lyrics';
const AUDIBLE_EDGE = 'audible';
/**
 * WESTERN_NOTES nodes carry up to 500KB of MusicXML. Excluded UNCONDITIONALLY
 * (flag on or off, spec §1): even flag-on users never pay the score download on
 * a plain bhajan page view — the viewer route lazy-fetches the node itself.
 */
const WESTERN_NOTES_EDGE = 'westernNotes';

/**
 * The set of node ids whose FULL data a bhajan detail view needs: the bhajan
 * itself, its non-lyrics 1-hop neighbours (ragam/talam/deity/composer/bb/…),
 * and — through the `audible` node — the linked `track`/`album` (2-hop). The
 * slim index carries every node's edges, so this is computed locally and
 * resolved in a single getMulti call. Lyrics are fetched separately.
 */
export function collectDetailNodeIds(
  bhajan: AnyGraphNode,
  byId: Map<number, AnyGraphNode>
): number[] {
  const ids = new Set<number>([bhajan.nodeId]);
  for (const e of bhajan.edges ?? []) {
    if (e.name === LYRICS_EDGE || e.name === WESTERN_NOTES_EDGE) continue;
    ids.add(e.nodeId);
    if (e.name === AUDIBLE_EDGE) {
      const audible = byId.get(e.nodeId);
      for (const ae of audible?.edges ?? []) ids.add(ae.nodeId);
    }
  }
  return Array.from(ids);
}
